/*
 * @Author: liuzhongyu
 * @Date: 2023-02-15 13:15:22
 * @LastEditors: zhang lin
 * @LastEditTime: 2023-03-08 10:59:01
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  downLoadALL: '批量下载',
  logFile: '日志文件',
  operate: '操作',
  log: '日志',
  download: '下载',
  selectNull: '请选择需要下载的日志',
  empty: '日志为空',
});
